import * as React from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";

import { handleError } from "~/utils/logger";
import { isWeb } from "~/utils/platform";

const KIDMIN_REFERRAL_KEY = "@kidminReferral";

export const useKidminReferral = () => {
  const [isKidmin, setIsKidmin] = React.useState(false);

  React.useEffect(() => {
    const checkKidminReferral = async () => {
      try {
        if (isWeb) {
          const urlParams = new URLSearchParams(window.location.search);
          const referral = urlParams.get("referral");

          if (referral === "kidmin") {
            sessionStorage.setItem(KIDMIN_REFERRAL_KEY, "true");
            setIsKidmin(true);
          } else {
            const storedReferral = sessionStorage.getItem(KIDMIN_REFERRAL_KEY);
            setIsKidmin(storedReferral === "true");
          }
        } else {
          const referral = await AsyncStorage.getItem(KIDMIN_REFERRAL_KEY);
          setIsKidmin(referral === "true");
        }
      } catch (error) {
        handleError(error);
      }
    };

    checkKidminReferral();
  }, []);

  const setKidminReferral = React.useCallback(async (value: boolean) => {
    try {
      if (isWeb) {
        sessionStorage.setItem(KIDMIN_REFERRAL_KEY, value.toString());
      } else {
        await AsyncStorage.setItem(KIDMIN_REFERRAL_KEY, value.toString());
      }
      setIsKidmin(value);
    } catch (error) {
      handleError(error);
    }
  }, []);

  return {
    isKidmin,
    setKidminReferral,
  };
};
